export const defaultPaymentAlerts = {
  REQUEST_ORG_MISMATCH_TITLE: 'Payment Request Error',
  REQUEST_ORG_MISMATCH_DESCRIPTION:
    'This payment request cannot be processed.  Please try again or contact customer support.',
  PAYMENT_FORBIDDDEN_TITLE: 'Forbidden access',
  INITIATOR_REQUEST_ERROR_TITLE: 'Insufficient Permissions',
  INITIATOR_REQUEST_ERROR_DESCRIPTION:
    'You do not have permission to make payment requests. Please contact the user administration team.',
  PAYMENT_REQUEST_FORBIDDDEN_TITLE: 'Insufficient Permissions',
  PAYMENT_REQUEST_FORBIDDDEN_DESCRIPTION: "You don't have permission to make payment requests",
  PAYMENT_APPROVER_FORBIDDDEN_TITLE: 'Insufficient Permissions',
  PAYMENT_APPROVER_FORBIDDDEN_DESCRIPTION: 'You do not have permission to approve payment requests. ',
  PAYMENT_INITIATOR_FORBIDDDEN_TITLE: 'Insufficient Permissions',
  PAYMENT_INITIATOR_FORBIDDDEN_DESCRIPTION:
    'You do not have permission to make payment requests. Please contact the user administration team.',
  PAYMENT_REQUEST_ALREADY_PROCCESSED_TITLE: 'Payment Request Error',
  PAYMENT_REQUEST_ALREADY_PROCCESSED_DESCRIPTION: 'This payment request has already been processed.',
  PAYMENT_OWN_REQUEST_ERROR_TITLE: 'Workflow Error',
  PAYMENT_OWN_REQUEST_ERROR_DESCRIPTION:
    'You cannot approve or reject a payment request that you submitted. ',
  PAYMENT_INVALID_ROLE_ERROR_TITLE: 'Invalid Role',
  PAYMENT_INVALID_ROLE_ERROR_DESCRIPTION:
    'You do not have the correct permissions to complete this request.  Please contact customer support.',
  ALL_PAYMENT_REQUESTS_FAILED_TITLE: 'Payment Requests Failed',
  ALL_PAYMENT_REQUESTS_FAILED_DESCRIPTION:
    'Your payments could not be processed. Please try again or contact support.',
  PAYMENT_RECORD_NOT_FOUND_TITLE: 'Payment Not Found',
  PAYMENT_RECORD_NOT_FOUND_DESCRIPTION:
    'Unable to retrieve payment details.  Please contact customer support.',
  PAYMENT_SUMMARY_NOT_FOUND_TITLE: 'PaymentSummary Failed',
  PAYMENT_SUMMARY_NOT_FOUND_DESCRIPTION: 'Unable to display payment summary information. Please try again.',
  INSUFFICIENT_BALANCE_TITLE: 'Insufficient balance',
  INSUFFICIENT_BALANCE_DESCRIPTION:
    'Your account balance is insufficient to complete this payment. Please add funds and try again.',
  TARGET2_BIC_AND_ADDRESS_REQUIRED_TITLE: 'BIC and Address Required',
  TARGET2_BIC_AND_ADDRESS_REQUIRED_DESCRIPTION: 'BIC and Address are required for Target2 payments.',
  EXCEEDED_TRANSFER_LIMIT_TITLE: 'Exceeded Transfer Limit',
  EXCEEDED_TRANSFER_LIMIT_DESCRIPTION: 'TThe transfer amount exceeds the transfer limit for SEPA transfers.',
  PAYMENT_REQUEST_FAILED_TITLE: 'Payment Request Failed',
  PAYMENT_REQUEST_FAILED_DESCRIPTION:
    'Your payment could not be processed. Please try again or contact support.',
  INVALID_AMOUNT_TITLE: 'Invalid Payment Amount',
  INVALID_AMOUNT_DESCRIPTION: 'The amount entered is invalid. Please enter a correct amount and try again.',
  AMOUNT_TOO_LOW_TITLE: 'Amount Too Low',
  AMOUNT_TOO_LOW_DESCRIPTION:
    'Please enter an amount higher than ${amountPlusFees} to proceed with the transaction.',
  PAYMENT_FAILED_BIC_REQUIRED_TITLE: 'Payment Validation Error',
  PAYMENT_FAILED_BIC_REQUIRED_DESCRIPTION: 'BIC code required for Target2 payments.',
  PAYMENT_FAILED_ADDRESS_REQUIRED_TITLE: 'Payment Validation Error',
  PAYMENT_FAILED_ADDRESS_REQUIRED_DESCRIPTION: 'BIC code required for Target2 payments.',
  PAYMENT_READER_FORBIDDDEN_TITLE: 'Forbidden access',
  PAYMENT_READER_FORBIDDDEN_DESCRIPTION: "You don't have permission to read payment request",
  WITHDRAW_SUCCESS_TITLE: 'Withdrawal initiated successfully',
  WITHDRAW_SUCCESS_DESCRIPTION: 'Your withdrawal request has been processed successfully.',
  CUSTOMER_IS_NOT_ENROLLED_TITLE: 'Personal information mismatch',
  CUSTOMER_IS_NOT_ENROLLED_DESCRIPTION: `Your sign in details don't match with our records.  Please contact support for help`,
  SCHEDULED_PAYMENT_CANCELLED_FAILED_TITLE: 'Scheduled Payment Cancel Failed',
  SCHEDULED_PAYMENT_CANCELLED_FAILED_DESCRIPTION: 'Unable to cancel scheduled payment. Please try again.',
  PAYMENTS_CANCELLED_FAILED_TITLE: 'Failed To Cancel Payment',
  PAYMENTS_CANCELLED_FAILED_DESCRIPTION: 'Unable to cancel payment. Please try again.',
  SCHEDULED_PAYMENT_CANCELLED_TITLE: 'Scheduled Payment Cancelled',
  SCHEDULED_PAYMENT_CANCELLED_DESCRIPTION: 'Scheduled payment has been cancelled successfully.',
  PAYMENTS_CANCELLED_TITLE: 'Payment Cancelled',
  PAYMENTS_CANCELLED_DESCRIPTION: 'Payment has been cancelled successfully.',
  EQUALS_EXCHANGE_NEXT_TRADING_DAY_REQUIRED_TITLE: 'Exchange not available on selected date',
  EQUALS_EXCHANGE_NEXT_TRADING_DAY_REQUIRED_DESCRIPTION:
    'This currency pair is not tradable on the selected date. Please use the next available trading day.',
  EQUALS_PAYMENT_EXCHANGE_TARGET_CURRENCY_UNRESOLVED_TITLE: 'Target currency unavailable',
  EQUALS_PAYMENT_EXCHANGE_TARGET_CURRENCY_UNRESOLVED_DESCRIPTION:
    'The payment currency could not be determined for this beneficiary. Please review the beneficiary currency details.',
  EQUALS_PAYMENT_EXCHANGE_UNSUPPORTED_FROM_SUB_BUDGET_TITLE:
    'Payment exchange not supported from this budget',
  EQUALS_PAYMENT_EXCHANGE_UNSUPPORTED_FROM_SUB_BUDGET_DESCRIPTION:
    'Cross-currency payments through Equals can only be initiated from the parent account balance budget.',
  SUBMIT_WITHDRAWAL_NOTICE_TITLE: 'Notice submitted',
  SUBMIT_WITHDRAWAL_NOTICE_DESCRIPTION:
    'Your notice has been submitted. Your withdrawal will be processed after the notice period has ended.',
  FAIL_WITHDRAWAL_NOTICE_TITLE: 'Notice could not be submitted',
  FAIL_WITHDRAWAL_NOTICE_DESCRIPTION:
    'We could not submit your notice. Please check the details and try again.',
  DESCRIPTION_LIMIT_VALIDATION_ERROR_TITLE: 'Description/Reference too long',
  DESCRIPTION_LIMIT_VALIDATION_ERROR_DESCRIPTION:
    'Description/Reference must not exceed {{characterLimit}} characters',
};
